import { useRef, useState, useEffect } from "react";
import { tooltipPositionType } from "../types/common";

export const useTooltipPosition = (
  isVisible: boolean,
  defaultPosition: tooltipPositionType = "top"
) => {
  const [currentPosition, setCurrentPosition] =
    useState<tooltipPositionType>(defaultPosition);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const triggerRef = useRef<HTMLDivElement>(null);

  const updatePosition = () => {
    if (tooltipRef.current && triggerRef.current) {
      const tooltip = tooltipRef.current;
      const trigger = triggerRef.current;
      const triggerRect = trigger.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const viewportHeight = window.innerHeight;

      if (triggerRect.bottom + tooltipRect.height > viewportHeight) {
        setCurrentPosition("top");
      } else {
        setCurrentPosition(defaultPosition);
      }
    }
  };

  useEffect(() => {
    if (isVisible) {
      updatePosition();
    }
  }, [isVisible, defaultPosition]);

  return {
    currentPosition,
    tooltipRef,
    triggerRef,
    updatePosition
  };
};
